@if (isFieldLocked('insuranceStatus')) {
  <app-locked-quote-alert class="qui-form-layout__col-center"></app-locked-quote-alert>
}
<app-form-card title="What brings you to Kin today?" icon="lucideGoal" class="qui-form-layout__col-center" formDisplayAddress="{{ formDisplayAddress }}">
  @if (isAutoAdvanceEnabled()) {
    <p class="sr-only">Selecting an option will immediately submit the form and take you to the next page. You cannot navigate backwards and change your selection.</p>
  }
  <form [formGroup]="insuranceStatusForm" (ngSubmit)="handleSubmit($event)" id="quote-form" class="mt-600">
    <fieldset class="form-group__fieldset" [appReadonlyRadioGroup]="isFieldLocked('insuranceStatus')" [appFocusOnlyRadioGroup]="isAutoAdvanceEnabled()">
      <legend class="sr-only">Select your insurance status</legend>
      <div class="grid gap-200 md:grid-cols-4">
        @for (insuranceStatusOption of insuranceStatusOptions; track insuranceStatusOption) {
          <label
            class="radio-card radio-card--block group focus-within:ring-primary focus-within:ring-2"
            [class.radio-card--invalid]="showError"
            [for]="insuranceStatusOption.id"
            [attr.data-testid]="'insurance-status-' + insuranceStatusOption.id"
          >
            <div class="radio-card__header flex flex-col gap-100">
              <ng-icon [name]="insuranceStatusOption.icon" size="24" class="radio-card__icon !overflow-visible"></ng-icon>
              <span class="radio-card__title w-full leading-200 font-medium group-has-[:checked]:font-bold">{{ insuranceStatusOption.label }} </span>
            </div>
            <input class="radio-card__control peer outline-none" type="radio" [id]="insuranceStatusOption.id" [value]="insuranceStatusOption.id" formControlName="insuranceStatus" />
          </label>
        }
      </div>
    </fieldset>
    @if (showError) {
      <div class="fs-body-md fw-medium text-warning mt-300 flex items-center gap-100" role="alert" data-testid="form-error-message">
        <ng-icon name="lucideCircleAlert" size="16" class="!overflow-visible" aria-hidden="true"></ng-icon>
        Please make a selection
      </div>
    }
  </form>
</app-form-card>
